var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5996 12L13.9329 12.7294C13.5793 13.1161 13.0997 13.3333 12.5997 13.3333C12.0997 13.3333 11.6202 13.1161 11.2665 12.7294C10.9124 12.3434 10.4329 12.1267 9.93308 12.1267C9.43321 12.1267 8.95372 12.3434 8.59961 12.7294",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59961 12.2168C2.59961 11.8907 2.59961 11.7276 2.63645 11.5742C2.66911 11.4381 2.72298 11.3081 2.79609 11.1888C2.87855 11.0542 2.99385 10.9389 3.22445 10.7083L11.5996 2.33316C12.1519 1.78087 13.0473 1.78087 13.5996 2.33316C14.1519 2.88544 14.1519 3.78087 13.5996 4.33316L5.22447 12.7083C4.99386 12.9389 4.87856 13.0542 4.74401 13.1367C4.62471 13.2098 4.49465 13.2637 4.3586 13.2963C4.20515 13.3332 4.04209 13.3332 3.71597 13.3332H2.59961V12.2168Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit04);
export default __webpack_public_path__ + "static/media/edit-04.c08f65157b77c6bb3b9e6a1d244e24c2.svg";
export { ForwardRef as ReactComponent };